import React from 'react';
import { Delete } from 'shared/components/ui/ProjectIcons';

type DeleteButtonProps = {
  onClick: () => void;
  className?: string;
  ariaLabel?: string;
  disabled?: boolean;
  iconSize?: number;
};

const DeleteButton: React.FC<DeleteButtonProps> = ({
  onClick,
  className = 'text-ui-status-error-destructive p-2 mx-2 h-12 transition-all duration-300 cursor-pointer disabled:opacity-50 disabled:cursor-not-allowed',
  ariaLabel = 'Delete',
  disabled = false,
  iconSize,
}) => {
  return (
    <button
      type="button"
      className={className}
      onClick={onClick}
      aria-label={ariaLabel}
      disabled={disabled}
    >
      <Delete size={iconSize} />
    </button>
  );
};

export default DeleteButton;
